import { useState, useEffect } from "react";
import { makeStyles } from "@mui/styles";
import Paper from "@mui/material/Paper";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Button from "@mui/material/Button";
import { rltAlunoNotaBimestreTipo } from "../../api-relatorio";
import CircularProgress from "@mui/material/CircularProgress";
import SimpleDialogMessage from "../../../../util/SimpleDialogMessage/SimpleDialogMessage";
import { useLocation, useNavigate } from "react-router-dom";
import { errorMessage } from "../../../../util/ConfirmAlertUtil";
import AlunoProfile from "../../../Aluno/AlunoProfile";
import NotaBimestreTipoProfile from "../../../NotaBimestreTipo/NotaBimestreTipoProfile";
import AlunoTurmaProfileViewV2 from "../../../AlunoTurma/AlunoTurmaProfileViewV2";
import NotaBimestreTableV2 from "../../../NotaBimestre/NotaBimestreTableV2";
import ConceitoAlunoTableV2 from "../../../ConceitoAluno/ConceitoAlunoTableV2";

const useStyles = makeStyles({
  paper: {
    padding: "20px",
    backgroundColor: "white",
  },
  title: {
    textAlign: "center",
  },
  loading: {
    marginTop: "20px",
    marginBottom: "20px",
  },
  voltarButton: {
    "@media print": {
      display: "none",
    },
  },
});

export default function RelatorioAlunoNotaBimestreTipoWeb() {
  const classes = useStyles();
  const [alunoNotaBimestreTipo, setAlunoNotaBimestreTipo] = useState(null);
  const location = useLocation();
  const codAluno = location.state.codAluno;
  const codNotaBimestreTipo = location.state.codNotaBimestreTipo;
  const [isLoading, setIsLoading] = useState(true);
  const [message] = useState({
    title: "",
    description: "",
  });
  const history = useNavigate();

  useEffect(() => {
    setIsLoading(true);
    rltAlunoNotaBimestreTipo(codAluno, codNotaBimestreTipo).then((data) => {
      if (data) {
        if (data.error) {
          errorMessage(data.message);
        } else {
          setAlunoNotaBimestreTipo(data);
        }
      }
      setIsLoading(false);
    });
  }, [codAluno, codNotaBimestreTipo]);

  const handleGoBack = () => {
    history(-1);
  };

  return (
    <div>
      <SimpleDialogMessage
        title={message.title}
        description={message.description}
      />
      <Container className={classes.paper} component={Paper}>
        <Button
          onClick={handleGoBack}
          variant="contained"
          color="secondary"
          className={classes.voltarButton}
        >
          <ArrowBackIcon style={{ marginRight: "10px" }} />
          Voltar
        </Button>
        {alunoNotaBimestreTipo && (
          <div style={{ marginTop: "20px", marginBottom: "100px" }}>
            <Typography className={classes.title} variant="h5">
              Relatório Aluno, Nota Bimestre Tipo
            </Typography>
            <AlunoProfile aluno={alunoNotaBimestreTipo.aluno} />
            <NotaBimestreTipoProfile
              notaBimestreTipo={alunoNotaBimestreTipo.notaBimestreTipo}
            />
            {alunoNotaBimestreTipo.listAlunoTurmaNotaBimestreConceito.map(
              (atnbc) => (
                <div
                  key={atnbc.alunoTurma.codigo}
                  style={{ marginTop: 50 }}
                >
                  <AlunoTurmaProfileViewV2 alunoTurma={atnbc.alunoTurma} />
                  <NotaBimestreTableV2
                    listNotaBimestre={atnbc?.listNotaBimestre}
                  />
                  <ConceitoAlunoTableV2
                    listConceitoAluno={atnbc?.listConceitoAluno}
                  />
                </div>
              ),
            )}
          </div>
        )}
        {isLoading ? (
          <div className={classes.loading}>
            <CircularProgress color="primary" /> Carregando...
          </div>
        ) : (
          ""
        )}
      </Container>
    </div>
  );
}
